import Button from "../button";
import {ChevronLeft, ChevronRight, Pencil, Plus, TrashIcon} from "../../assets/icons";
import React, {useEffect, useState} from "react";
import useModal from "../modal/useModal";
import UseContext from "../../hooks/useContext";
import Badge from "../badge/badge";
import { parseCalendarDate } from "../../helper/helper";
import IconTooltip from "../iconTooltip/IconTooltip";

const ScheduleWeekList = ({ indexScheduleWeek, scheduleWeek, isPrevious, isNext, isHidden, setScheduleWeekDisplay }) => {
    const {toggle} = useModal()
    const {activeScheduleWeekDay, setActiveScheduleWeekDay, setData, data, updSchedule, setUpdSchedule, language} = UseContext()
    const label = (key, defaultValue) =>
        language.getValue(`missionCreation.scheduleList.${key}`, defaultValue)
    const deleteWeekLabel = label('deleteWeek', 'Supprimer la semaine')
    const previousWeekLabel = label('previousWeek', 'Semaine précédente')
    const nextWeekLabel = label('nextWeek', 'Semaine suivante')
    const [isScheduleWithPeriods, setIsScheduleWithPeriods] = useState(false)

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    
    const openModalAddEditScheduleWeek = (indexScheduleWeek, indexScheduleWeekDay) => {
        setActiveScheduleWeekDay([indexScheduleWeek, indexScheduleWeekDay]);
        toggle('cM_addScheduleWeek')
    }

    const openModalDeleteScheduleWeekDay = (indexScheduleWeek, indexScheduleWeekDay) => {
        setActiveScheduleWeekDay([indexScheduleWeek, indexScheduleWeekDay]);
        toggle('cM_deleteScheduleWeekDay')
    }

    const openModalDeleteScheduleWeek = (indexScheduleWeek) => {
        setActiveScheduleWeekDay([indexScheduleWeek, 0]);
        toggle('cM_deleteScheduleWeek')
    }

    useEffect(() => {
        let scheduleWithPeriods = false;
        scheduleWeek?.days?.map((day, indexScheduleWeekDay) => {
            if(!!day?.periods){
                scheduleWithPeriods = true;
            }
        })

        if(scheduleWithPeriods){
            setIsScheduleWithPeriods(true)
        }
        else{
            setIsScheduleWithPeriods(false)
        }

        setUpdSchedule(false)
    }, [scheduleWeek, updSchedule]);

    useEffect(() => {
    }, [scheduleWeek?.days]);

    return (
        <div key={indexScheduleWeek} className={`flex flex-col gap-3 ${isHidden ? 'hidden' : null}`}>
            <div className={'flex items-center justify-between'}>
                <div className={'ft-lg text-gray-900 font-medium'}>{scheduleWeek.name}</div>
                    <div className={'flex gap-2'}>
                            <IconTooltip label={deleteWeekLabel}>
                                <Button size={'SMI'}
                                        color={isScheduleWithPeriods ? 'SECONDARY' : 'DISABLED'}
                                        disabled={isScheduleWithPeriods ? null : 'disabled'}
                                        onClick={() => openModalDeleteScheduleWeek(indexScheduleWeek)}
                                        ariaLabel={deleteWeekLabel}
                                >
                                    <TrashIcon wh={24} color={isScheduleWithPeriods ? '#111827' : '#6B7280'}/>
                                </Button>
                            </IconTooltip>
                            <IconTooltip label={previousWeekLabel}>
                                <Button size={'SMI'}
                                        color={isPrevious ? 'SECONDARY' : 'DISABLED'}
                                        disabled={isPrevious ? null : 'disabled'}
                                        onClick={() => setScheduleWeekDisplay(indexScheduleWeek - 1)}
                                        ariaLabel={previousWeekLabel}
                                >
                                    <ChevronLeft wh={24} color={isPrevious ? '#111827' : '#6B7280'}/>
                                </Button>
                            </IconTooltip>
                            <IconTooltip label={nextWeekLabel}>
                                <Button size={'SMI'}
                                        color={isNext ? 'SECONDARY' : 'DISABLED'}
                                        disabled={isNext ? null : 'disabled'}
                                        onClick={() => setScheduleWeekDisplay(indexScheduleWeek + 1)}
                                        ariaLabel={nextWeekLabel}
                                >
                                    <ChevronRight wh={24} color={isNext ? '#111827' : '#6B7280'}/>
                                </Button>
                            </IconTooltip>
                </div>
            </div>
            <div className={'flex flex-col gap-3'}>
                {
                    scheduleWeek?.days?.map((day, indexScheduleWeekDay) => {
                        const monthList = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
                        const cal = parseCalendarDate(day.date);
                        const year = cal.getFullYear()
                        const dayNumber = cal.getDate()
                        const month = monthList[cal.getMonth()]
                        const weekday = cal.toLocaleDateString("fr-FR", {weekday: "long", timeZone: "Europe/Paris"});

                        return (
                            <div key={indexScheduleWeekDay} className={'flex justify-between p-4 border rounded-md'}>
                                <div className={'my-auto'}>
                                    <div>
                                        {capitalizeFirstLetter(weekday)} {dayNumber} {month} {year}
                                    </div>
                                    {
                                        !!day?.periods ? (
                                            <div className={'flex gap-2'}>
                                                {
                                                    day?.periods.periode_one_start && day?.periods.periode_one_end ? (
                                                        <div className={'ft-sm'}>
                                                            <Badge type={day?.periods.periode_one_start === '00:00' && day?.periods.periode_one_end === '00:00' ? 'PRIMARY' : 'WARNING'}>
                                                                {day?.periods.periode_one_start === '00:00' && day?.periods.periode_one_end === '00:00' ? 'Non travaillé' : `${day?.periods.periode_one_start} > ${day?.periods.periode_one_end}`}
                                                            </Badge>
                                                        </div>
                                                    ) : null
                                                }
                                                {
                                                    day?.periods.periode_two_start && day?.periods.periode_two_end ? (
                                                        <div className={'ft-sm'}>
                                                            <Badge type={'WARNING'}>
                                                                {day?.periods.periode_two_start} > {day?.periods.periode_two_end}
                                                            </Badge>
                                                        </div>
                                                    ) : null
                                                }
                                                {
                                                    day?.periods.periode_three_start && day?.periods.periode_three_end ? (
                                                        <div className={'ft-sm'}>
                                                            <Badge type={'WARNING'}>
                                                                {day?.periods.periode_three_start} > {day?.periods.periode_three_end}
                                                            </Badge>
                                                        </div>
                                                    ) : null
                                                }
                                            </div>
                                        ) : null
                                    }
                                    <div></div>
                                </div>
                                <div className={'my-auto flex gap-3'}>
                                    {
                                        !!day?.periods ? (
                                            <>
                                                <div className={'my-auto'}>
                                                    <IconTooltip label={label('deleteDay', 'Supprimer')}>
                                                        <Button size={'SMI'} color={'SECONDARY'}
                                                                onClick={() => openModalDeleteScheduleWeekDay(indexScheduleWeek, indexScheduleWeekDay)}
                                                                ariaLabel={label('deleteDayLabel', 'Supprimer la journée')}
                                                        >
                                                            <TrashIcon wh={24} color={'#111827'}/>
                                                        </Button>
                                                    </IconTooltip>
                                                </div>
                                                <div className={'my-auto'}>
                                                    <IconTooltip label={label('editDay', 'Modifier')}>
                                                        <Button size={'SMI'} color={'SECONDARY'}
                                                                onClick={() => openModalAddEditScheduleWeek(indexScheduleWeek, indexScheduleWeekDay)}
                                                                ariaLabel={label('editDayLabel', 'Modifier la journée')}
                                                        >
                                                            <Pencil wh={24} color={'#111827'}/>
                                                        </Button>
                                                    </IconTooltip>
                                                </div>
                                            </>
                                        ) : (
                                            <IconTooltip label={label('addDay', 'Ajouter')}>
                                                <Button size={'SMI'} color={'SECONDARY'}
                                                        onClick={() => openModalAddEditScheduleWeek(indexScheduleWeek, indexScheduleWeekDay)}
                                                        ariaLabel={label('addDayLabel', 'Ajouter une journée')}
                                                >
                                                    <Plus wh={'15'} color={'#111827'} className='fill-gray-400'/>
                                                </Button>
                                            </IconTooltip>
                                        )
                                    }
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default ScheduleWeekList;